import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
import DailyPointsSummaryTable from "../../features/manageFeedbackReports/dailyPointsSummaryTable";
import InactiveUsersReportTable from "../../features/manageFeedbackReports/inactiveUsersReportTable";
import ReportsTopbar from "../../features/manageFeedbackReports/reportsTopbar";
import { showError } from "../../helpers";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageFeedbackReports = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Feedback, Reports & Logs</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Feedback, Reports & Logs
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Feedback & Ratings" {...a11yProps(0)} />
              <Tab label="Exportable Reports" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <PromotionFeedbackTable />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Daily Points Summary" {...a11yProps(0)} />
              <Tab label="Inactive Users Report" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs1} index={0}>
            {/* <ReportsTopbar type="Transactions" /> */}
            <DailyPointsSummaryTable />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={1}>
            {/* <ReportsTopbar type="UserReport" /> */}
            <InactiveUsersReportTable />
          </CustomTabPanel>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageFeedbackReports;
